<!-- 安基代辦分錄明細 -->
<template>
    <div class="row">
        <div class="col-12">
            <ListForm
                api
                labelPosition="top"
                :formTitle="title"
                :recordToEdit="recordToEdit"
                :formType="formType"
            >
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" class="mb10" plain @click="print">查詢</el-button>
                    <el-button type="primary" class="mb10" plain @click="print('pdf')">列印</el-button>
                    <!-- 查詢結果 -->
                    <el-table :data="tableData" v-if="showList" max-height="600" stripe border>
                        <el-table-column type="index" align="center" width="50" fixed></el-table-column>
                        <el-table-column
                            v-for="(item,index) in columns"
                            :prop="item.prop"
                            :label="item.label"
                            :key="index"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <div v-if="item.addcomma">{{ $addcomma(scope.row[item.prop]) }}</div>
                                <div
                                    v-else-if="item.transferDate"
                                >{{ $transferDate(scope.row[item.prop]) }}</div>
                                <div v-else>{{ scope.row[item.prop] }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </ListForm>
        </div>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";
export default {
    name: "ins_plan_entry",
    components: { ListForm },
    data() {
        return {
            title: "安基代辦分錄明細",
            columns: [
                { prop: "voucherDate", label: "傳票日期", transferDate: true },
                { prop: "voucherCode", label: "傳票號" },
                { prop: "memberAccount", label: "帳號" },
                { prop: "memberName", label: "姓名" },
                { prop: "insPlanApplyNumber", label: "申請件號" },
                { prop: "accountTitleCode", label: "會計科目代號" },
                { prop: "accountTitleName", label: "會計科目名稱" },
                { prop: "debitAmount", label: "借方金額", addcomma: true },
                { prop: "creditAmount", label: "貸方金額", addcomma: true },
                { prop: "summary", label: "摘要" }
            ],
            tableData: [],
            showList: false,
            // 傳票類別預設繳費；key 要先建立，之後改值才有反應性
            recordToEdit: { entryType: "premium", insPlanMainCode: "" },
            formType: [
                {
                    label: "查詢日期-起",
                    key: "dateStart",
                    type: "date",
                    require: true
                },
                {
                    label: "查詢日期-迄",
                    key: "dateEnd",
                    type: "date",
                    require: true
                },
                {
                    label: "傳票類別",
                    key: "entryType",
                    type: "radio",
                    options: [
                        { label: "繳費", value: "premium" },
                        { label: "補助", value: "subsidy" },
                        { label: "墊款", value: "advance" },
                        { label: "沖銷", value: "deal" }
                    ]
                },
                {
                    label: "方案主代碼",
                    key: "insPlanMainCode",
                    type: "select",
                    value: "code",
                    labelValue: "name",
                    // 墊款一張傳票含整批社員且可能跨方案，故該類別停用此欄
                    disabled: false,
                    options: []
                }
            ]
        };
    },
    watch: {
        "recordToEdit.entryType": {
            handler(type) {
                const mainCodeField = this.formType.find(
                    field => field.key === "insPlanMainCode"
                );
                mainCodeField.disabled = type === "advance";
                if (mainCodeField.disabled) {
                    this.recordToEdit.insPlanMainCode = "";
                }
            },
            immediate: true
        }
    },
    created() {
        this.getInsPlanMainList();
    },
    methods: {
        /**
         * 取得本社可用的安基方案下拉選項
         */
        async getInsPlanMainList() {
            const mainCodeField = this.formType.find(
                field => field.key === "insPlanMainCode"
            );
            const params = { page: "{}", where: JSON.stringify({ filter: {} }) };
            try {
                const json = await this.mAxiosGet(API.coopInsPlan, params);

                const list = (json.resultData.data || [])
                    .map(plan => ({
                        code: plan.code,
                        name: plan.name
                    }));
                mainCodeField.options = [{ code: "", name: "全部" }].concat(list);
            } catch (error) {
                // 錯誤訊息已由 mAxiosGet 顯示，下拉維持只有「全部」
            }
        },
        /**
         * 查詢或列印分錄明細
         * @param {string} type 傳入 "pdf" 為列印，其餘為畫面查詢
         */
        async print(type) {
            try {
                this.checkField();
            } catch (error) {
                this.$message.error(error.message);
                return;
            }

            const url = API.coopEntryReport;
            // get 參數
            const params = {
                action: "InsPlanEntry",
                dateStart: this.recordToEdit.dateStart,
                dateEnd: this.recordToEdit.dateEnd,
                entryType: this.recordToEdit.entryType,
                insPlanMainCode: this.recordToEdit.insPlanMainCode
            };

            if (type == "pdf") {
                // pdf
                params.action = "InsPlanEntryPdf";
                this.mDownloadFile(url, false, "", params);
                return;
            }

            // list
            this.showList = false;
            this.tableData = [];
            try {
                const json = await this.mAxiosGet(url, params, true);
                this.tableData = json.resultData.data || [];
                this.showList = true;
            } catch (error) {
                // 查無資料等錯誤訊息已由 mAxiosGet 顯示，維持不展開列表
            }
        },
        /**
         * 查詢條件檢核
         */
        checkField() {
            if (!this.recordToEdit.dateStart || !this.recordToEdit.dateEnd) {
                this.$message.closeAll();
                throw new Error("請選擇起訖日期");
            }
            if (!this.recordToEdit.entryType) {
                this.$message.closeAll();
                throw new Error("請選擇傳票類別");
            }
        }
    }
};
</script>
